import React, {ReactNode} from 'react';
import {
    Card,
    Empty,
    Flex,
    Space,
    Tag, Typography,
} from 'antd';

import {
    HistoryOutlined, LinkOutlined,
} from '@ant-design/icons';
import {EntityChangeLog} from "../../../../../../../models/logger/logger.data";

const { Text } = Typography;

interface InvoicatonLogLink {
    invocation: string;
}

interface EntityChangeLogsTabProps {
    changeLogs: EntityChangeLog[];
}

function renderParams(record: Record<string, string>): string {
    return Object.entries(record)
        .map(([key, value]) => `${key}: ${value}`)
        .join(', ');
}

const renderInvocationLogLink = ({
                                     invocation,
                                 }: InvoicatonLogLink): ReactNode => {

    return (
        <a
            href={'#'}
            className="invocation-entity-link"
            onClick={(event) => {
                event.preventDefault();
            }}
        >
            <LinkOutlined />
            <span>...{invocation.slice(-8)}</span>
        </a>
    );
};

export function EntityChangeLogsTab({
                                            changeLogs,
                                        }: EntityChangeLogsTabProps) {
    if (!changeLogs.length) {
        return <Empty description="No change logs" />;
    }

    return (
        <div className="invocation-change-list">
            {changeLogs.map((changeLog, index) => {

                return (
                    <Card
                        key={`${changeLog.date}-${changeLog.invocation}-${index}`}
                        className="invocation-change-card"
                        bordered={false}
                    >
                        <div className="invocation-change-card__top">
                            <Space size={8} wrap>
                                <HistoryOutlined />
                                <Text type="secondary">{changeLog.date}</Text>

                                {renderInvocationLogLink({
                                    invocation: changeLog.invocation,
                                })}
                            </Space>

                            <Tag color="purple">
                                Changes: {changeLog.changesCount || '—'}
                            </Tag>

                            <Tag color="green">
                                {changeLog.operation}
                            </Tag>
                        </div>

                        <div className="invocation-change-card__fields">
                            <Text type="secondary">Changed fields:</Text>

                            {changeLog.changes.length ? (
                                <Flex gap={6} wrap="wrap">
                                    {changeLog.changes.map((change) => (
                                        <Tag key={change.field} className="invocation-field-tag">
                                            {change.field}: {change.old ? (change.old + ' → ' ) : ''} {change.new}
                                        </Tag>
                                    ))}
                                </Flex>
                            ) : (
                                <Text>—</Text>
                            )}

                            <Flex gap={6} wrap="wrap" style={{marginTop: "10px"}}>
                                <Tag color={"yellow"} key={'action'} className="invocation-field-tag">
                                    action: {changeLog.action}
                                </Tag>
                                {changeLog.actionParams ? (
                                    <Tag color={"yellow"} key={'params'} className="invocation-field-tag">
                                        params: {renderParams(changeLog.actionParams)}
                                    </Tag>
                                ) : null}
                                <Tag color={"yellow"} key={'channel'} className="invocation-field-tag">
                                    channel: {changeLog.channel}
                                </Tag>
                                <Tag color={"yellow"} key={'ip'} className="invocation-field-tag">
                                    ip: {changeLog.ip}
                                </Tag>
                            </Flex>
                        </div>
                    </Card>
                );
            })}
        </div>
    );
}